<template>
  <div>
    <app-header>
      <template #title>
        <h1 class="d-inline me-4">Lead</h1>
        <span v-if="loaded" class="status" :class="statusClass">{{ lead.status }}</span>
      </template>
    </app-header>

    <ul id="horizontal-nav" class="nav nav-horizontal">
      <router-link
        tag="li"
        class="nav-item"
        :to="{ name: 'leads.overview' }"
      >
        <a class="nav-link">Overview</a>
      </router-link>
    </ul>

    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      loaded: false
    }
  },

  computed: {
    ...mapState('lead', {
      lead: 'single'
    }),

    statusClass () {
      return {
        New: 'status-primary',
        Contacted: 'status-info',
        Closed: 'status-success',
        Spam: 'status-danger'
      }[this.lead.status] || ''
    }
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('lead', { getLead: 'getSingle' }),

    loadData () {
      this.getLead(this.$route.params.lead_id).then(() => {
        this.loaded = true
      })
    }
  }
}
</script>
